// extracted by mini-css-extract-plugin
export var title = "title-module--title--c00c5";
export var title__h2 = "title-module--title__h2--d46b9";